var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAi = function SvgIconAi(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F39",
    fillOpacity: 0.88,
    d: "m8.388 15.507.008-.001q.008 0 .01.012l.012.284-.003.012-.008.01-.069.05-.008.002-.01-.002-.07-.05-.006-.008-.003-.014.011-.285.003-.007q.005-.006.016-.004l.047.024.01.003.013-.003z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F39",
    fillOpacity: 0.88,
    d: "m8.563 15.432.01-.002q.009.003.012.015l.023.41-.003.009q-.006.008-.019.005l-.134-.061-.005-.006-.004-.008-.012-.286.002-.008.007-.006z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F39",
    fillOpacity: 0.88,
    d: "M8.086 15.43q.005 0 .01.002l.122.061.007.007.002.008-.012.286-.002.008-.007.005-.134.062-.01.001q-.01-.004-.011-.016l.022-.409.004-.01z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F39",
    fillOpacity: 0.88,
    d: "M6.071 3.633c.4-1.167 2.011-1.202 2.484-.106l.04.106.538 1.574a2.67 2.67 0 0 0 1.517 1.607l.145.054 1.573.537c1.167.399 1.202 2.011.107 2.484l-.107.04-1.573.538a2.67 2.67 0 0 0-1.608 1.517l-.054.144-.538 1.574c-.398 1.167-2.01 1.202-2.482.107l-.042-.107-.537-1.573a2.67 2.67 0 0 0-1.517-1.608l-.144-.054-1.574-.538c-1.167-.398-1.202-2.01-.106-2.482l.106-.042 1.574-.537A2.67 2.67 0 0 0 5.48 5.351l.054-.144zm6.596-2.299a.67.67 0 0 1 .598.373l.032.078.234.684.684.234a.666.666 0 0 1 .08 1.23l-.08.032-.684.233-.233.685a.667.667 0 0 1-1.23.078l-.032-.078-.233-.684-.685-.234a.666.666 0 0 1-.079-1.23l.08-.032.683-.233.233-.685a.67.67 0 0 1 .632-.451"
  })));
};
export default SvgIconAi;